import {useGetAndSet} from "./useGetAndSet";
import {createSetPartOrdersData} from "../actions/dataActions";


export const usePartOrdersData = (params, dataFresh) => {
    return useGetAndSet("partorders", params, createSetPartOrdersData, dataFresh);
}